export default __webpack_public_path__ + "static/media/azure-esb.6022b9bd.svg";